import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useState } from "react";
import MDInput from "../../components/MDInput";
import {
  createReadingCall,
  uploadReadingCall,
  getAccountByNumberCall,
  getConsumptionReceiptData,
} from "../../api/api";
import DefaultInfoCard from "../../examples/Cards/InfoCards/DefaultInfoCard";
import MDButton from "../../components/MDButton";
import MobileNavbar from "../../examples/Navbars/MobileNavbar";
import { consumptionPrint } from "../../helpers/print/consumption";
import CameraCapture from "../../components/Camera/camera";
import { dataURLtoFile } from "helpers/dataUrlToFile";
import moment from "moment";

export default function Consumptions() {
  const [state, setState] = useState({
    accountNo: "",
    account: null,
    noResult: false,
    confirmed: false,
    reading: "",
    lastReading: "",
    submitted: false,
  });

  const [image, setImage] = useState(null);

  const units = state.reading - state.lastReading;
  const getAccount = async () => {
    if (state.accountNo) {
      const account = await getAccountByNumberCall(state.accountNo);
      if (account) {
        setState({
          ...state,
          accountNo: account ? "" : state.accountNo,
          account: account,
          noResult: account == null,
          confirmed: false,
          reading: "",
          submitted: false,
          lastReading: account.last_reading,
        });
      } else {
        setState({
          ...state,
          noResult: true,
        });
      }
    } else {
      global.showAlert(
        "Please add account number.",
        "Account number is required to get the account details",
        "warning"
      );
    }
  };

  const confirm = () => {
    setState({ ...state, confirmed: true });
  };

  const onSubmit = () => {
    if (!Number(state.reading)) {
      global.showDialog("Invalid Reading", "Please enter a valid Reading before submitting.");
      return;
    }
    global.showConfDialog(
      "Are you sure?",
      <span>
        This action will add the latest reading
        <span
          style={{
            color: "#007afb",
            fontWeight: "bold",
            margin: "0px 10px",
          }}
        >
          {state.reading}
        </span>
        to account number
        <span
          style={{
            color: "#007afb",
            fontWeight: "bold",
            margin: "0px 10px",
          }}
        >
          {state.account.account_number} - ({state.account.holder_name})
        </span>
      </span>,
      () => {
        handleAddReading();
      },
      ["Confirm", "Cancel"]
    );
  };

  const handleAddReading = async () => {
    if (!Number(state.reading)) {
      global.showAlert("Invalid Reading", "", "warning");
      return;
    }
    if (!state.account) {
      global.showAlert("Account not found", "", "warning");
      return;
    }
    var imageUrl;
    if (image) {
      const file = dataURLtoFile(image, `${state.account.id}_${moment().format("YYYYMMDDHHmmss")}.jpg`);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("account_id", state.account.id);
      const fileResponse = await uploadReadingCall(formData);
      imageUrl = fileResponse.url;
    }
    const reading = await createReadingCall({
      account_id: state.account.id,
      current_reading: Number(state.reading),
      image_url: imageUrl,
    });
    if (reading) {
      setState({ ...state, submitted: true });
    }
  };

  const goBack = () => {
    setState({
      accountNo: "",
      account: null,
      noResult: false,
      confirmed: false,
      reading: "",
      submitted: false,
      lastReading: "",
    });
  };

  const printReceipt = async () => {
    const data = await getConsumptionReceiptData(state.account.id);
    if (data) {
      consumptionPrint(data);
    }
  };
  return (
    <DashboardLayout>
      <MobileNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Consumptions
                </MDTypography>
              </MDBox>
              {!state.account && (
                <MDBox pt={3} px={2}>
                  <Grid
                    container
                    alignItems={"center"}
                    justifyContent={"center"}
                    mb={2}
                    spacing={1}
                  >
                    <Grid item>
                      <MDInput
                        type="number"
                        label="Enter Account Number.."
                        value={state.accountNo}
                        onChange={(event) => {
                          setState({ ...state, accountNo: event.target.value });
                        }}
                        style={{
                          width: "250px",
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            getAccount();
                          }
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <MDButton
                        onClick={() => {
                          getAccount();
                        }}
                        variant="gradient"
                        color="dark"
                      >
                        Search
                      </MDButton>
                    </Grid>
                  </Grid>
                </MDBox>
              )}

              {state.noResult && (
                <MDBox mx={"auto"} my={3} width="fit-content">
                  <MDTypography>Account Not Found!</MDTypography>
                </MDBox>
              )}
              {state.account && (
                <MDBox pt={3} pb={3}>
                  <DefaultInfoCard
                    title={state.account.holder_name}
                    description={state.account.address}
                    icon="person"
                    noShadow
                  />
                  {state.confirmed && !state.submitted && (
                    <MDBox
                      mb={2}
                      mx={"auto"}
                      my={3}
                      width="fit-content"
                      display="flex"
                      flexDirection="column"
                    >
                      <MDInput
                        type="number"
                        label="Last Reading"
                        value={state.lastReading}
                        disabled
                        style={{
                          width: "250px",
                        }}
                      />
                      <MDBox height={10} />
                      <CameraCapture image={image} setImage={setImage} />
                      <MDBox height={10} />
                      <MDInput
                        type="number"
                        label="Current Reading"
                        value={state.reading}
                        onChange={(event) => {
                          setState({ ...state, reading: event.target.value });
                        }}
                        style={{
                          width: "250px",
                        }}
                      />
                      <MDBox height={10} />
                      <MDInput
                        type="number"
                        label="Units"
                        value={units >= 0 ? units : ""}
                        disabled
                        style={{
                          width: "250px",
                        }}
                      />
                    </MDBox>
                  )}

                  {state.confirmed && state.submitted && (
                    <MDBox mx={"auto"} width="fit-content" color="green">
                      Record Added Successfully!
                    </MDBox>
                  )}

                  {!state.submitted && (
                    <MDBox mx={"auto"} mt={3} width="fit-content">
                      <MDButton
                        style={{
                          width: "120px",
                          margin: "2px",
                        }}
                        onClick={state.confirmed ? onSubmit : confirm}
                        variant="gradient"
                        color="info"
                        disabled={state.confirmed ? units < 0 : false}
                      >
                        {state.confirmed ? "submit" : "confirm"}
                      </MDButton>
                      <MDButton
                        style={{
                          width: "120px",
                          margin: "2px",
                        }}
                        onClick={goBack}
                        variant="gradient"
                        color="error"
                      >
                        cancel
                      </MDButton>
                    </MDBox>
                  )}

                  {state.confirmed && (
                    <MDBox mx={"auto"} mt={1} width="fit-content">
                      <MDButton
                        style={{
                          width: "244px",
                        }}
                        onClick={printReceipt}
                        variant="gradient"
                        color={state.submitted ? "success" : "light"}
                      >
                        print receipt
                      </MDButton>
                    </MDBox>
                  )}
                  {state.confirmed && state.submitted && (
                    <MDBox mx={"auto"} mt={1} width="fit-content">
                      <MDButton
                        style={{
                          width: "244px",
                        }}
                        onClick={goBack}
                        variant="gradient"
                        color={"dark"}
                      >
                        Go Back
                      </MDButton>
                    </MDBox>
                  )}
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}
